import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export default function CTA() {
    return (
        <Box
            sx={{
                width: '100%',
                position: 'relative',
                textAlign: 'center',
                color: 'white',
                pt: 4,
                pb: 4,
                backgroundImage: 'url(/img/hero-bg.png)', // Replace with your image path
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}
        >
            <Container maxWidth="sm" sx={{ position: 'relative', zIndex: 1 }}>
                {/* Small Blue Text */}
                <Typography
                    variant="subtitle1"
                    sx={{
                        color: '#1e88e5',
                        fontWeight: 'bold',
                        mb: 2,
                    }}
                >
                    Ready to Connect and Collaborate?
                </Typography>

                {/* CTA Headline */}
                <Typography
                    variant="h2"
                    sx={{
                        fontSize: '32px',
                        fontWeight: '600',
                        mb: 4,
                    }}
                >
                    Join Our Thriving Community
                </Typography>

                {/* Button */}
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    href="/apply"
                    target="_blank"
                >
                    Become a Member
                </Button>
            </Container>
        </Box>
    );
}
